import React from 'react';
import { Alert, Label } from 'reactstrap';
import FormikInputField from '~/components/formikInputField/formikInputField';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import FormLayout from '~/components/formLayout/formLayout';

const HSCodeForm = ({ errors, touched, handleSubmit, isSubmitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <FormLayout title="HS Code overview">
        <div className="mb3">
          <Label>Name</Label>
          <FormikInputField name="name" invalid={!!errors.name} />
          {errors.name && (
            <p data-qa="name-error" className="error">
              {errors.name}
            </p>
          )}
        </div>
        <div className="mb3">
          <Label>Description</Label>
          <FormikInputField type="textarea" name="description" />
        </div>
      </FormLayout>
      <div className="flex justify-end mt4">
        <SubmissionButton data-qa="hscode-save" color="primary" type="submit" isSubmitting={isSubmitting}>
          Save
        </SubmissionButton>
      </div>
    </form>
  );
};

export default HSCodeForm;



// WEBPACK FOOTER //
// ./src/components/hsCodeForm/hsCodeForm.jsx